import { format, isValid, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { store } from '../redux/Store';

type FormatOptions = { timezone?: string | null };

const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

// Get the timezone from the Redux store's authReducer user object
const getStoreTimezone = (): string | null => {
  const timezone = store.getState().authReducer.user?.timezone;
  return typeof timezone === 'string' && timezone ? timezone : null;
};

const formatWithTimezone = (
  date: string | Date,
  fallbackFormat: string,
  customFormat?: string,
  options?: FormatOptions
): string => {
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  if (!isValid(dateObj)) {
    return 'Invalid Date';
  }

  const fmt = customFormat ?? fallbackFormat;
  const timezone = options?.timezone ?? getStoreTimezone();

  // Checked whether it is just a calendar date (without the time)
  if (!timezone || (typeof date === 'string' && DATE_ONLY_REGEX.test(date))) {
    return format(dateObj, fmt);
  }

  try {
    return formatInTimeZone(dateObj, timezone, fmt);
  } catch {
    return format(dateObj, fmt);
  }
};

export const formatDate = (
  date: string | Date | undefined | null,
  customFormat?: string,
  options?: FormatOptions
): string => {
  if (!date) return '';

  return formatWithTimezone(date, 'MM-dd-yyyy', customFormat, options);
};

export const formatDateTime = (
  date: Date | string | undefined | null,
  customFormat?: string,
  options?: FormatOptions
): string => {
  if (!date) return '';

  return formatWithTimezone(date, 'MM-dd-yyyy hh:mm:ss a', customFormat, options);
};
